let _config = null;
/**
 * Initialize the Maps SDK with OSRM/tile server URL.
 * Call this once at app startup (e.g. in main.tsx).
 * To use a self-hosted OSRM server, pass { apiBaseUrl: "https://your-server" }
 */
export function initMaps(config) {
    _config = {
        defaultDistanceUnit: "miles",
        h3Resolution: 9,
        tileStyleUrl: "https://tiles.openfreemap.org/styles/liberty",
        ...config,
    };
}
export function getMapsConfig() {
    if (!_config) {
        _config = {
            tileStyleUrl: "https://tiles.openfreemap.org/styles/liberty",
            defaultDistanceUnit: "miles",
            h3Resolution: 9,
        };
    }
    return _config;
}
/** Not used anymore — only internal maps server URLs matter */
export function getApiKey() {
    return "";
}
/**
 * Returns the self-hosted OSRM/Photon server URL if configured.
 * If undefined, client.ts falls back to public APIs (OSRM demo + Photon komoot).
 */
export function getApiBaseUrl() {
    return getMapsConfig().apiBaseUrl;
}
export function getGeocodingUrl() {
    return getMapsConfig().geocodingUrl;
}
export function getTileStyleUrl() {
    return getMapsConfig().tileStyleUrl ?? "https://tiles.openfreemap.org/styles/liberty";
}
export function getH3Resolution() {
    return getMapsConfig().h3Resolution ?? 9;
}
export function getDistanceUnit() {
    return getMapsConfig().defaultDistanceUnit ?? "miles";
}
//# sourceMappingURL=config.js.map